import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateAsNumberService {

    constructor() {

    }

    dateAsNumber(): number {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        let day = date.getDate().toString();
        let hour = date.getHours().toString();
        let min = date.getMinutes().toString();
        let secs = date.getSeconds().toString();
        day = day.length === 1 ? '0' + day : day;
        hour = hour.length === 1 ? '0' + hour : hour;
        min = min.length === 1 ? '0' + min : min;
        secs = secs.length === 1 ? '0' + secs : secs;
        const result = min + secs;
        return +result;
    }
}
